export default __webpack_public_path__ + "static/media/template-img-4-large.f3ee36bf.jpg";